var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffQ110(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1882",
    "data-name": "Groupe 1882",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.235,
    height: 59.262,
    viewBox: "0 0 59.235 59.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heater",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M35.769,58.164a3.949,3.949,0,0,1-.228-5.462V50.99a3.425,3.425,0,0,1-1.481.347A3.46,3.46,0,0,1,30.6,47.881V46.4H28.63v1.481a3.456,3.456,0,0,1-6.911,0V46.4H19.745v1.481a3.433,3.433,0,0,1-4.936,3.109V52.7a3.949,3.949,0,1,1-5.923,0V50.99a3.425,3.425,0,0,1-1.481.347,3.46,3.46,0,0,1-3.456-3.456V44.426A3.952,3.952,0,0,1,0,40.477V34.554A3.953,3.953,0,0,1,3.949,30.6V16.783A3.954,3.954,0,0,1,0,12.834V10.859A3.952,3.952,0,0,1,3.949,6.911V3.456a3.455,3.455,0,1,1,6.91,0V4.936h1.975V3.456a3.455,3.455,0,1,1,6.91,0V4.936h1.974V3.456a3.456,3.456,0,0,1,6.911,0V4.936H30.6V3.456a3.456,3.456,0,0,1,6.911,0V4.936H39.49V3.456a3.456,3.456,0,0,1,6.911,0V46.4H50.35a2.965,2.965,0,0,0,2.961-2.962V38.4a4.945,4.945,0,0,1-3.949-4.837V31.592a1.977,1.977,0,0,1,1.974-1.975V24.681a.987.987,0,0,1,1.975,0v4.936h1.975V24.681a.987.987,0,0,1,1.974,0v4.936a1.978,1.978,0,0,1,1.975,1.975v1.974A4.945,4.945,0,0,1,55.286,38.4v5.036a4.943,4.943,0,0,1-4.936,4.936h-4a3.417,3.417,0,0,1-4.887,2.615V52.7a3.949,3.949,0,0,1-5.7,5.462Z",
    transform: "translate(0 0)",
    fill: "rgba(129,139,142,0.23)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(16.468 16.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.639,7.83a.426.426,0,0,0-.37-.216H6.693L7.628.473A.428.428,0,0,0,6.843.195L.063,12.073a.426.426,0,0,0,.363.648H5.918l-.741,7.153a.428.428,0,0,0,.789.262L12.633,8.259a.426.426,0,0,0,.005-.428Z",
    transform: "translate(0 0)",
    fill: "#3a484d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffQ110);
export default __webpack_public_path__ + "static/media/off_Q1_10_.a2f5c0478ba963741e88b1e0225e7b15.svg";
export { ForwardRef as ReactComponent };